import * as RoutePathConstants from '../../../constants/RoutePathConstants'
import consumptionRecord from './views/consumption-record'

export default [
  {
    path: RoutePathConstants.CONSUMPTION_RECORD,
    name: 'consumptionRecord',
    component: consumptionRecord
  }
]



// WEBPACK FOOTER //
// ./src/pages/wx-member/member-consuming-records/routers.js